exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flag-remove{position:relative;cursor:pointer}.flag-remove__reason{display:block;position:absolute;border:1px solid #767676;bottom:0px;left:0px;background-color:#fff;border-radius:4px;z-index:99;width:100%;max-width:max-content;width:200px}.flag-remove__reason p{color:black;z-index:100}.flag-remove:hover .flag-remove__reason{display:block}\n", ""]);

// exports
